import type { ComponentProps } from 'react';

import { Avatar } from './Avatar';
import { cn } from './cn';
import { ContactCardContainer } from './ContactCardContainer';

type LoadingContactCardProps = ComponentProps<'div'> & {
  onToggleChecked?: boolean;
};

export function LoadingContactCard({ onToggleChecked, className }: LoadingContactCardProps) {
  return (
    <div className={cn('flex animate-pulse', className)}>
      {onToggleChecked && <div className="size-6" />}
      <ContactCardContainer>
        <Avatar className="size-17.5" srcs={[]} alt="" />
      </ContactCardContainer>
    </div>
  );
}

export const LoadingContacts = ({ onToggleChecked }: LoadingContactCardProps) => (
  <>
    <LoadingContactCard onToggleChecked={onToggleChecked} />
    <LoadingContactCard onToggleChecked={onToggleChecked} className="opacity-50" />
    <LoadingContactCard onToggleChecked={onToggleChecked} className="opacity-20" />
  </>
);
